import Swiper from "swiper11";
import sideBar1_Init from "@common/components/sideBar-1";
import dialogFormInit from "@common/components/dialogForm-1";
import { Autoplay, Navigation, Pagination, Thumbs } from "swiper11/modules";
import { addDefaultTabelStyle, initFancyBox, mainInit } from "@common/utils/initUtils";
import { createdSwiper } from "@common/utils/swiperUtils";
import { filpHeight } from "@common/utils/additionalUtils";
import { ImportBundle, handleSendInquiry } from "@common/utils/utils";
import global from "./common";
const common = () => {
  addDefaultTabelStyle();
  initFancyBox();
  ImportBundle({ type: "js" }, [
    {
      src: "https://static.addtoany.com/menu/page.js",
      async: true,
      fn: () => {
        const a2a_config = window.a2a_config || {};
        a2a_config.onclick = 1;
        window.a2a_config = a2a_config;
      },
    },
    {
      src: "https://static.yigetechcms.com/public/js/bootstrap@4.6.2.min.js",
    },
  ]);
  ImportBundle({ type: "css" }, [
    "https://static.yigetechcms.com/public/css/bootstrap@4.6.2.min.css",
    "https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css",
  ]);
};

const initEvent = () => {
  filpHeight(".productList-4 .productList-4_SEO .showBtn", ".productList-4 .productList-4_SEO article", 3);
  dialogFormInit();
  sideBar1_Init();
  handleSendInquiry({ formId: "#Inquiry-form", trigger: "#Inquiry-submit" });
  $(".faq-1 .faq-1-right .list > li article > header").on("click", (e) => {
    $(e.currentTarget).siblings(".faq-1-des").slideToggle(200);
    $(e.currentTarget).parents("li").eq(0).toggleClass("active");
  });
  handleSendInquiry({
    formId: ".contactUs-4 #contactUs-4-Form",
    trigger: ".contactUs-4 #contactUs-4-Submit",
  });
  $(".contactUs-4 .contactUs-4_faq .list > li article > header").on("click", function () {
    const content = $(this).siblings(".contactUs-4-des");
    if (content.length) {
      content.slideToggle(250);
    }
  });
};

const initSwiper = () => {
  new Swiper(".aboutUs-6 .aboutUs-6-designers .swiper-box .swiper", {
    modules: [Autoplay, Pagination],
    loop: true,
    spaceBetween: 30,
    speed: 650,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: ".aboutUs-6 .aboutUs-6-designers .swiper-box .swiper-pagination",
      clickable: true,
    },
  });

  new Swiper(".aboutUs-6-showroom .showroom-box .main-swiper .swiper", {
    modules: [Autoplay, Thumbs, Navigation],
    loop: true,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 650,
    spaceBetween: 30,
    navigation: {
      prevEl: ".aboutUs-6-showroom .showroom-box .thumbs-swiper .prev",
      nextEl: ".aboutUs-6-showroom .showroom-box .thumbs-swiper .next",
    },
    on: {
      beforeInit: (swiper) => {
        createdSwiper(swiper, ".aboutUs-6-showroom .showroom-box .thumbs-swiper .swiper", {
          swiperOptions: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        });
      },
    },
  });
  new Swiper(".productDetail-1 .productDetail-1_main .main-swiper .swiper", {
    modules: [Autoplay, Thumbs, Navigation],
    loop: true,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 650,
    spaceBetween: 30,
    navigation: {
      prevEl: ".productDetail-1 .productDetail-1_main .thumbs-swiper .prev",
      nextEl: ".productDetail-1 .productDetail-1_main .thumbs-swiper .next",
    },
    on: {
      beforeInit: (swiper) => {
        createdSwiper(swiper, ".productDetail-1 .productDetail-1_main .thumbs-swiper .swiper", {
          swiperOptions: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        });
      },
    },
  });
};

mainInit([global, common, initEvent, initSwiper]);
